
export default Object.freeze({
  UPDATE: Symbol('update'),
  UPDATE_CONTROLS: Symbol('update_controls'),
  UI_CHANGE: Symbol('ui_change')
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/Events.js